var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "recording-consent-screen-content",
      attrs: { "data-cy": "recording-consent-screen-content" },
    },
    [
      _c(
        "div",
        { staticClass: "content-div" },
        [
          _c("RecordingConsentModal", {
            attrs: {
              shouldCloseWindow: _vm.shouldCloseWindow,
              "agree-btn-text": _vm.agreeBtnText,
              "leave-btn-text": _vm.leaveBtnText,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }